var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation-dialog"},[_c('p',[_vm._v(_vm._s(_vm.mensaje))]),_c('button',{on:{"click":_vm.confirmar}},[_vm._v("Aceptar")]),_c('button',{on:{"click":_vm.cancelar}},[_vm._v("Cancelar")])])}
var staticRenderFns = []

export { render, staticRenderFns }